module.exports = __webpack_public_path__ + "img/translation.cd54dec9.png";